import { defineStore } from 'pinia'
import useWheelAnalysisQuery from "@/composables/useWheelAnalysisQuery";
import { useAnalysisStore } from "@/stores/Setup/analysis";
import axios from "axios";

function dataUrlToFile(dataUrl, fallbackName = 'center_image.png') {
    if (typeof dataUrl !== 'string' || !dataUrl.startsWith('data:')) {
        throw new Error('previewImage must be a data URL string');
    }
    const [meta, b64] = dataUrl.split(',');
    const mimeMatch = meta.match(/data:(.*?);base64/);
    const mime = mimeMatch ? mimeMatch[1] : 'application/octet-stream';

    const binary = atob(b64);
    const len = binary.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);

    // Use File when available (all modern browsers). Fallback to Blob if needed.
    try {
        return new File([bytes], fallbackName, { type: mime });
    } catch {
        const blob = new Blob([bytes], { type: mime });
        blob.name = fallbackName; // not standard, but some libs read it
        return blob;
    }
}

export const useImageStore = defineStore('image', {
    state: () => {
        return {
            imageFile: null,
            previewImage: null
        }
    },
    getters: {},
    actions: {
        async fetchWheelAnalysis() {
            await useWheelAnalysisQuery()
        },

        async imageFileChanged() {
            const analysisStore = useAnalysisStore();
            const id = analysisStore.wheelAnalysisId;

            if (!this.previewImage || !id) return;

            let file;
            try {
                // If previewImage is already a File/Blob, use it; otherwise convert
                file = (typeof this.previewImage === 'string')
                    ? dataUrlToFile(this.previewImage, 'center_image.png')
                    : this.previewImage;
            } catch (e) {
                console.error('Failed to convert data URL:', e);
                return;
            }

            const fd = new FormData();
            // Always include a filename; many servers expect one
            const filename = (file && file.name) ? file.name : 'center_image.png';
            fd.append('image_file', file, filename);

            try {
                const resp = await axios.put(
                    `${process.env.VUE_APP_API_ROOT}api/v1/wheel_analyses/${id}/image_file`,
                    fd
                    // Don’t set Content-Type; the browser will add the proper multipart boundary
                    // { headers: { 'Content-Type': 'multipart/form-data' } }
                );
                console.log('image updated!', resp.data);
            } catch (err) {
                console.log('error:', err);
            }
        },
    },
    persist: true
});
